import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useLegalReturnLink from "../hooks/useLegalReturnLink";
import {
  markLegalTabOpenedFromFlow,
  readSafeReturnToQuery,
  shouldCloseLegalTab,
} from "../utils/legalFlowReturn";

function readHasOpener() {
  try {
    return Boolean(window.opener);
  } catch (_) {
    return false;
  }
}

function isPlainLeftClick(event) {
  return (
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey &&
    !event.defaultPrevented
  );
}

/**
 * Back link for terms and privacy. A tab opened from another page closes
 * itself so the origin form keeps its data. A direct visit navigates.
 */
export default function LegalBackLink() {
  const location = useLocation();
  const navigate = useNavigate();
  const { returnTo, returnLabel } = useLegalReturnLink(location);
  const hasSafeReturnTo = Boolean(readSafeReturnToQuery(location.search));

  useEffect(() => {
    markLegalTabOpenedFromFlow({
      hasOpener: readHasOpener(),
      historyLength: window.history.length,
      hasSafeReturnTo,
    });
  }, [hasSafeReturnTo]);

  const handleClick = (event) => {
    if (!isPlainLeftClick(event)) {
      return;
    }

    const closeTab = shouldCloseLegalTab({
      hasOpener: readHasOpener(),
      historyLength: window.history.length,
      hasSafeReturnTo,
    });
    if (!closeTab) {
      return;
    }

    event.preventDefault();
    let closed = false;
    try {
      window.close();
      closed = window.closed;
    } catch (_) {
      closed = false;
    }
    if (!closed) {
      navigate(returnTo);
    }
  };

  return (
    <Link to={returnTo} onClick={handleClick}>
      {returnLabel}
    </Link>
  );
}
